<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.RegistrationStatusEnum.Values;
}>();

const label = computed(() => Enums.RegistrationStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "R":
            return "bg-gray-500";
        case "S":
            return "bg-sky-500";
        case "A":
            return "bg-pink-500";
        case "P":
            return "bg-orange-500";
        case "I":
            return "bg-sky-500";
        case "F":
            return "bg-purple-500";
        case "C":
            return "bg-red-500";
        case "D":
            return "bg-green-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
